import { createSlice } from "@reduxjs/toolkit";

const tagsSlice = createSlice({
  name: "tags",
  initialState: [],
  reducers: {
    setTags(state, action) {
      return action.payload;
    },
    addTag(state, action) {
      state.push(action.payload);
    },
    removeTag(state, action) {
      return state.filter((tag) => tag._id !== action.payload);
    },
  },
});

export const { setTags, addTag, removeTag } = tagsSlice.actions;
export default tagsSlice.reducer;
